import { render, staticRenderFns } from "./courseRecordItem.vue?vue&type=template&id=633b4ca1&scoped=true&"
import script from "./courseRecordItem.vue?vue&type=script&lang=js&"
export * from "./courseRecordItem.vue?vue&type=script&lang=js&"
import style0 from "./courseRecordItem.vue?vue&type=style&index=0&id=633b4ca1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633b4ca1",
  null
  
)

export default component.exports